import DashboardLayoutModal from "./container"
// import './style.css'
/** 
 * @module DashboardLayoutModal
 * @description 戰情室新增、編輯。
 */
export default DashboardLayoutModal;